import type { GetLatestObligationInternalAuditResultByObligationIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetLatestInternalAuditReportObligationAssessmentResultByObligationIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetLatestInternalAuditReportObligationAssessmentResultByObligationIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetLatestObligationInternalAuditResultByObligationIdArgs = {
  obligationId: string;
};

export const useGetLatestObligationInternalAuditResultByObligationId =
  createQueryHook<
    UseGetLatestObligationInternalAuditResultByObligationIdArgs,
    GetLatestObligationInternalAuditResultByObligationIdResponseRow[],
    GetLatestInternalAuditReportObligationAssessmentResultByObligationIdQuery
  >({
    trpcQueryOptions: (trpc, { obligationId }) =>
      trpc.frontend.internalAuditResult.latestObligationInternalAuditResultByObligationId.queryOptions(
        { obligationId }
      ),
    mapTrpcDataToGraphQL: (data) => ({
      obligation_internal_audit_result: data,
    }),
    graphqlDocument:
      GetLatestInternalAuditReportObligationAssessmentResultByObligationIdDocument,
    graphqlVariables: ({ obligationId }) => ({ ObligationId: obligationId }),
  });
